const Dialog = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return {};
    },
    paper: ({ ownerState, theme }) => ({
      border: "none",
    }),
  },
};

export default Dialog;
